/* eslint-disable no-process-env */
import { cookie } from '@ux/util';
import { getLocation } from './Location';
var hosts = ['dev-godaddy.com', 'dev-secureserver.net', 'dev-123-reg.co.uk', 'test-godaddy.com', 'test-secureserver.net', 'test-123-reg.co.uk', 'ote-godaddy.com', 'ote-secureserver.net', 'godaddy.com', 'secureserver.net', '123-reg.co.uk'];
var defaultHost = 'godaddy.com';

/**
 * Get the current environment from the site url
 * @returns {string} - the environment of the current site
 */
export function getEnv() {
  var host = getHost() || '';
  if (host.includes('dev-')) {
    return 'dev';
  } else if (host.includes('test-')) {
    return 'test';
  } else if (host.includes('ote-')) {
    return 'ote';
  }
  return 'prod';
}

/**
 * Get the url for the cart checkout api
 * @returns {string} - base cart checkout api url for the current site
 */
export function getBaseApiUrl() {
  var _process, _process$env;
  if (typeof process !== 'undefined' && (_process = process) !== null && _process !== void 0 && (_process$env = _process.env) !== null && _process$env !== void 0 && _process$env.STORYBOOK_NOTIFICATIONS_API) {
    return process.env.STORYBOOK_NOTIFICATIONS_API;
  }
  return "https://notifications-api.".concat(getHost());
}

/**
 * Get the hostname for the current site
 * @returns {string} - the hostname of the current site
 */
export function getHost() {
  var _ref = getLocation() || {},
    hostname = _ref.hostname;
  if (!hostname) return defaultHost;
  return hosts.find(function (host) {
    return hostname.includes(host);
  });
}

/**
 * Get the search params for the current url
 * @returns {object} - the search params for the current url
 */
export function getUrlParams() {
  var _getLocation = getLocation(),
    search = _getLocation.search;
  var searchParams = new URLSearchParams(search);
  return Object.fromEntries(searchParams.entries());
}
export function getCohortIdFromCookie(experimentId) {
  var _cohorts$experimentId;
  var pxCohorts = cookie.get('px_cohorts');
  if (!pxCohorts) {
    return null;
  }
  var cohorts = JSON.parse(decodeURIComponent(pxCohorts));
  return cohorts === null || cohorts === void 0 ? void 0 : (_cohorts$experimentId = cohorts[experimentId]) === null || _cohorts$experimentId === void 0 ? void 0 : _cohorts$experimentId.cohortId;
}
export function getUxHeader() {
  var _window$ux;
  var result = null;
  var _ref2 = ((_window$ux = window.ux) === null || _window$ux === void 0 ? void 0 : _window$ux.eldorado) || {},
    _ref2$header = _ref2.header,
    header = _ref2$header === void 0 ? null : _ref2$header;
  if (header && typeof header === 'function') {
    header(function (err, uxHeader) {
      if (!err) result = uxHeader;
    });
  }
  return result;
}
export var expirations = {
  oneHour: 60 * 60 * 1000,
  oneDay: 24 * 60 * 60 * 1000
};
export var getCookieExpiration = function getCookieExpiration() {
  var expiration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : expirations.oneHour;
  return new Date(Date.now() + expiration).toGMTString();
};
export function getSsoUrl() {
  var _window$location = window.location,
    host = _window$location.host,
    pathname = _window$location.pathname,
    search = _window$location.search;
  var path = encodeURIComponent("".concat(pathname).concat(search));
  var app = host.split('.')[0] || 'www';
  return "https://sso.".concat(getHost(), "/?realm=idp&path=").concat(path, "&app=").concat(app, "&auth_reason=1");
}
//# sourceMappingURL=utils.js.map